import { createAsyncAction, createAction } from 'typesafe-actions';
import { ContactInformationDto } from '../dtos/contactInformation';

export const getContactInformationActions = createAsyncAction(
  'GET_CONTACT_INFORMATION_REQUEST',
  'GET_CONTACT_INFORMATION_SUCCESS',
    'GET_CONTACT_INFORMATION_ERROR',
)<string, ContactInformationDto[], string>();

export const contactInformationShouldRefresh = createAction('REFRESH_CONTACT_INFORMATION')<boolean>();